import { Pipe, PipeTransform } from '@angular/core';
import template from 'lodash/template';

@Pipe({
  name: 'template',
})
export class TemplatePipe implements PipeTransform {
  transform(value: string, data: object): string {
    const compiled = template(value);
    return compiled({ data });
  }
}
